import { styled } from "@vitality-ds/system";
import BaseSidebarWrapperStyles from "./styles/BaseSidebarWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseSidebarWrapper = styled("div", BaseSidebarWrapperStyles);